import React, { Fragment } from 'react'
import {
    Create,
    TextInput,
    ReferenceInput,
    SelectInput,
    NumberInput
} from 'react-admin'

import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'

export const ProvinciaCreate = ({ permissions, ...props }) => {
    if (permissions === null) {
        return null
    }
    return (
        <Fragment>
            <Title title={"Crear Provincia"} />
            <Create {...props}>
                <CustomSimpleForm>
                    <NumberInput source="id" label="ID" />
                    <NumberInput source="code" label="Código" />
                    <TextInput source="name" label="Nombre" />
                    <ReferenceInput source="region" reference="regiones" label="Región" >
                        <SelectInput source="name" />
                    </ReferenceInput>
                </CustomSimpleForm>
            </Create>
        </Fragment>
    )
};
